/**
 * @typedef {{ value: string, label: string }} PickerOption
 */

/**
 * Normalize string[] or {value,label}[] to {value,label}[].
 * @param {Array<string | { value: string, label: string }>} options
 * @returns {PickerOption[]}
 */
export function normalizeOptions(options) {
	return options.map((o) => (typeof o === 'object' ? o : { value: o, label: o }));
}

/**
 * Find the label for a committed value.
 * @param {PickerOption[]} options
 * @param {string} value
 * @returns {string}
 */
export function labelFor(options, value) {
	const found = options.find((o) => o.value === value);
	return found ? found.label : value;
}

/**
 * Filter normalized options by query (case-insensitive over label and value).
 * @param {PickerOption[]} options
 * @param {string} query
 * @returns {PickerOption[]}
 */
export function filterOptions(options, query) {
	const q = query.toLowerCase();
	return options.filter((o) => o.label.toLowerCase().includes(q) || o.value.toLowerCase().includes(q));
}
